import axios from "axios";

const LOCAL_BASE = process.env.REACT_APP_BACKEND_URL;
const KEY = "pc_client_token";

export const clientToken = {
  get: () => localStorage.getItem(KEY),
  set: (t) => localStorage.setItem(KEY, t),
  clear: () => localStorage.removeItem(KEY),
};

const clientApi = axios.create({ baseURL: `${LOCAL_BASE}/api` });
clientApi.interceptors.request.use((config) => {
  const t = clientToken.get();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export default clientApi;
